import script from "./componentBase.vue?vue&type=script&lang=js"
export * from "./componentBase.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__